import React from 'react'
import { Link } from 'react-router'
import classes from './Profile.scss'
import TitleBox from '../Common/TitleBox/TitleBox'
import ColoredList from '../Common/ColoredList/ColoredList'

export default class Profile extends React.Component {
  constructor(props) {
    super(props)
    const username = props.params.username

    this.state = { username: username || props.username, friends: ['no friends :('], stats: { points: 0, gameCt: 0, winCt: 0, winRatio: 1 }, updated: false, isFriend: false }
    const self: any = this
    self.getUser = self.getUser.bind(self)
  }

  componentWillMount() {
    this.getUser()
  }

  sendChallenge(username) {
    // const { sending } = this.state
    const { baseUrl, openAlertModal } = this.props

    // if (sending) { return }
    this.setState({ sending: true })
    fetch(`${baseUrl}/challenges/new`, {
      method: 'POST',
      body: JSON.stringify({ username }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        const { result, gameId } = res
        // this.setState({ sending: false })
        if (result === 'ok') {
          if (gameId) {
            window.location.pathname = `/game/${gameId}`
          } else {
            openAlertModal('Challenge sent!')
          }
        } else {
          openAlertModal(res.message)
        }
      })
  }

  getUser() {
    const { baseUrl, params } = this.props
    const { username } = params

    fetch(`${baseUrl}/profile/${username}`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result == 'ok') {
          var data = res.data;
          var stats = { points: data.points, gameCt: data.gameCt, winCt: data.winCt, winRatio: data.winRatio }
          this.setState({ username, friends: data.friends, stats, isFriend: data.isFriend })
        } else {
          console.log('Error: ', res)
          window.location.href = '/home'
        }
      })
      .catch(err => {
        console.log('error: ', err)
      })
      .then(() => {
        this.setState({ updated: true })
      })
  }

  addFriend(name) {
    const { baseUrl, openAlertModal } = this.props
    fetch(`${baseUrl}/friends/add/${name}`, { credentials: 'include' })
      .then(res => res.json())
      .then(({ result, msg, err }) => {
        if (result === 'ok') { openAlertModal('Friend request sent!') }
        else { openAlertModal(`Error: ${msg || err}`) }
      })
  }

  goToFriend(name) {
    window.location.href = `/profile/${name}`
  }

  render() {
    const { params } = this.props
    const { stats, friends, username, isFriend } = this.state
    const { points, gameCt, winCt, winRatio } = stats
    const myUsername = this.props.username
    const isMe = myUsername === username

    return (<div style={{ height: '90%', display: 'flex', flexDirection: 'column', marginTop: '5em' }}>
      <div className={classes.outerBox}>
        <div className={[classes.box, classes.nameBox].join(' ')}>
          {username}
        </div>
        {!isMe && <div className={[classes.box, classes.actionBox].join(' ')}>
          {!isFriend && <span onClick={() => this.addFriend(username)}><i className="fa fa-plus-square" aria-hidden="true"></i>Add friend</span>}
          {isFriend && <span onClick={() => this.sendChallenge(username)}><i className="fa fa-plus-square" aria-hidden="true"></i>Send Challenge</span>}
        </div>}
      </div>
      <div className={classes.outerBox} style={{ flex: 1 }}>
        <div className={[classes.box, classes.statsBox].join(' ')}>
          <TitleBox title='Stats'>
            <ColoredList titles={'true'}>
              <li><label>Score:</label>{points}</li>
              <li><label>Games Played:</label>{gameCt}</li>
              <li><label>Games Won:</label>{winCt}</li>
              <li><label>Win/Loss Ratio:</label>{winRatio}</li>
            </ColoredList>
          </TitleBox>
        </div>
        <div className={[classes.box, classes.friendsBox].join(' ')}>
          {(isFriend || isMe) && friends.length > 0 && <TitleBox title='Friends'>
            <ColoredList>
              {friends.map(f => <li style={{ cursor: 'pointer' }} onClick={() => this.goToFriend(f)}>{f}</li>)}
            </ColoredList>
          </TitleBox>}
        </div>
      </div>
    </div>)
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Users/Profile.js
 **/